/* 场馆信息相关接口 */
import path from '@/api/index'
import {
    axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'

// 获取分类下拉数据
export function getClassOptions() {
    return axios({
        url: path.mobile + '/stock/getClassOptions',
        method: 'GET'
    })
}

// 分页
export function queryList(data) {
    return axios({
        url: path.mobile + '/stock',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}
